var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "align-items-center moregage-form w-auto" },
    [
      _c(
        "b-col",
        {
          staticClass: "order-lg-1 order-2",
          class: {
            "column-divider-right campaigns-details-divider": _vm.label,
          },
          attrs: { lg: "10" },
        },
        [
          _c(
            "b-row",
            { staticClass: "mb-2 align-items-center" },
            [
              _c("b-col", { attrs: { cols: "12", xl: "5", lg: "6" } }, [
                _c(
                  "p",
                  { staticClass: "bold text-light-gray font-sm mb-2 mb-lg-0" },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("global.words.subject")) +
                        "\n        "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12", xl: "6" } },
                [
                  _c("material-input", {
                    staticClass: "form-group-material-no-label",
                    attrs: {
                      "custom-expression": _vm.subjectCustomExpression,
                      disabled: _vm.disabled,
                      name: "subject",
                      label: _vm.$t("global.words.subject"),
                      "hidden-label": "",
                      placeholder: _vm.$t("global.words.subject"),
                    },
                    model: {
                      value: _vm.subject,
                      callback: function ($$v) {
                        _vm.subject = $$v
                      },
                      expression: "subject",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "row align-items-center" },
            [
              _c("b-col", { attrs: { cols: "12", xl: "5", lg: "6" } }, [
                _c(
                  "p",
                  { staticClass: "bold text-light-gray font-sm mb-2 mb-lg-0" },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("global.actions.previewText")) +
                        "\n        "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12", xl: "6" } },
                [
                  _c("material-input", {
                    staticClass: "form-group-material-no-label",
                    attrs: {
                      "custom-expression": _vm.previewTextCustomExpression,
                      disabled: _vm.disabled,
                      name: "previewText",
                      label: _vm.$t("global.actions.previewText"),
                      "hidden-label": "",
                      placeholder: _vm.$t("global.actions.previewText"),
                    },
                    model: {
                      value: _vm.previewText,
                      callback: function ($$v) {
                        _vm.previewText = $$v
                      },
                      expression: "previewText",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.label
        ? _c(
            "div",
            {
              staticClass:
                "col-lg text-lg-center order-lg-2 order-1 mb-lg-0 mb-2",
            },
            [
              _c("p", { staticClass: "bold text-gray text-uppercase m-0" }, [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("global.words.subject")) + "\n    "
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }